import { getFormattedDecimalValue, getCurrencyValue } from "@components/Amount";

import type { TierInvestment } from "../types";

type TieredInvestment = {
  investments: TierInvestment[];
};

export const getInvestmentTierAmount = (
  tierId: string,
  { investments }: TieredInvestment,
): number | undefined => {
  const tierInvestment = investments
    .find(({ projectTierId }) => projectTierId === tierId);

  if (!tierInvestment) {
    return undefined;
  }

  const { amount } = tierInvestment;

  return amount;
};

export const getInvestmentTierCurrency = (
  tierId: string,
  investment: TieredInvestment,
): string | null => {
  const amount = getInvestmentTierAmount(tierId, investment);

  const currencyValue = amount
    ? getCurrencyValue(getFormattedDecimalValue(0, amount, "plus"))
    : null;

  return currencyValue;
};

export { getCurrencyValue };
